import { COU_httpGet, COU_httpPost } from "@/utils/http";
import { Service_GetBranchRelId } from "@/service/branch_relId_service";
import store from "@/store";
// 商品预览前获取id，用于获取商品详情
async function WaitMoveGetId({ url, templateId }) {
  // 1688的是必须要传branchRelId
  const checkMall = store.state["mall_group"].checkMall;
  const params = url?.includes("detail.1688.com")
    ? `?branchRelId=${Service_GetBranchRelId(checkMall && checkMall.Id ? checkMall : null)}`
    : "";
  let r;
  if (checkMall && checkMall.Id) {
    r = await COU_httpPost({
      url: `/productMove/waitMove${params}&branchGroupRelId=${checkMall?.Id}`,
      data: { url, templateId },
    });
  } else {
    r = await COU_httpPost({
      url: `/productMove/waitMove${params}`,
      data: { url, templateId },
    });
  }

  let result = {},
    success = false,
    msg = "";
  try {
    result = r.result;
    success = r.success;
    msg = r.msg;
  } catch (error) {
    console.log(error);
  }
  if (!result) result = {};
  return { result, success, msg };
}

// 获取 淘特/1688 商品详情数据
async function GetGoodsDetail(logIds, catIds) {
  const checkMall = store.state["mall_group"].checkMall;
  const url = `/productMove/format?logIds=${logIds}${catIds ? `&catIds=${catIds}` : ""}&branchGroupRelId=${
    checkMall?.Id
  }&branchRelId=${Service_GetBranchRelId(checkMall)}`;
  const r = await COU_httpGet({ url });
  let result = {},
    msg = "",
    success = false;
  try {
    const item = r.result[logIds];
    msg = item.Msg;
    success = item.Success;
    result = item.Result;
  } catch (error) {
    console.log(error);
  }
  if (!r.success) {
    result = {};
    msg = r.msg;
  }
  if (!result) result = {};
  if (msg?.includes("没有预测到类目")) msg = "没有预测到类目 (商品模板里类目设置选择的是[跳过未匹配上的])";
  return { result, msg, success };
}

export { WaitMoveGetId, GetGoodsDetail };
